<div *ngIf="clientList | async as clients">
  <h2 class="pt-4">Clients</h2>
  <div class="marquee">
    <div class="marquee__inner">
      <div *ngFor="let client of clients">
        <img class="client-logo m-3" [alt]="client" [src]="'assets/images/clients/' + client"/>
      </div>
      <div *ngFor="let client of clients">
        <img class="client-logo m-3" [alt]="client" [src]="'assets/images/clients/' + client"/>
      </div>
    </div>
  </div>
</div>
